import { useContext } from "react";
import { useRouteLoaderData } from "react-router-dom";
import { providerStorage } from "@tiny/utils";
import type { RootLoader } from "@/types/RootLoader";
import { ProviderConfigContext } from "./ProviderConfigContext";
import { RouteKey, FeatureKey, ProviderConfig } from "./types";
import { isAllowed } from "./utils";

export const useRoute = (key: RouteKey): boolean => {
  const { allowedRoutes } = useContext(ProviderConfigContext);
  return isAllowed(key, allowedRoutes);
};

export const useFeature = (key: FeatureKey): boolean => {
  const { allowedFeatures } = useContext(ProviderConfigContext);
  return isAllowed(key, allowedFeatures);
};

export const useAllowedAutomations =
  (): ProviderConfig["allowedAutomations"] => {
    const { allowedAutomations } = useContext(ProviderConfigContext);
    return allowedAutomations;
  };

export const useProvider = (): string | null => providerStorage.getProvider();

// Authoritative provider, for use anywhere under the "root" route (which is
// everywhere authenticated except the brief pre-loader render) — reads
// userStatus.provider (authorization-server's AuthProviderView) instead of
// the user-controlled URL param / sessionStorage that useProvider() falls
// back on. Not accountInfo.providerIdentifier — that's an unrelated
// accountservice lookup key, never populated with the provider type.
export const useAccountProvider = (): string | null => {
  const { userStatus } = useRouteLoaderData("root") as RootLoader;
  return userStatus?.provider?.toLowerCase() ?? null;
};
